import { BROWSER } from 'esm-env';
import { ofetch } from 'ofetch';
import { log } from '@shared/log.browser.ts';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';
import { CrocotileClient } from '@tilelist/clients/CrocotileClient';
import type { CrocotileFeature } from '@tilelist/clients/CrocotileClient';
import { TrackingService } from '@tilelist/services/TrackingService.browser';
import { VariationLoadingService } from '@tilelist/services/VariationLoadingService';

/*                                                                                                    */
const CROCOTILE_INSTANCES = new Map<CrocotileFeature, CrocotileClient>();
const VARIATION_LOADING_SERVICES = new Map<CrocotileFeature, VariationLoader>();
let TRACKING_SERVICE: TrackingService | null = null;

/**
 *
 */
export function getCrocotileClient(feature: CrocotileFeature = 'tilelist'): CrocotileClient {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    const existing = CROCOTILE_INSTANCES.get(feature);
    if (existing) return existing;

    const client = new CrocotileClient({
        fetchClient: ofetch,
        logger: log,
        timeout: 2000,
        feature,
    });
    CROCOTILE_INSTANCES.set(feature, client);

    return client;
}

/**
 *
 */
export function getVariationLoadingService(feature: CrocotileFeature = 'tilelist'): VariationLoader {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    const existing = VARIATION_LOADING_SERVICES.get(feature);
    if (existing) return existing;

    const service = new VariationLoadingService(getCrocotileClient(feature));
    VARIATION_LOADING_SERVICES.set(feature, service);
    return service;
}

/**
 *
 *
 */
export function getTrackingService(): TrackingService {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    if (TRACKING_SERVICE) return TRACKING_SERVICE;

    TRACKING_SERVICE = new TrackingService();
    return TRACKING_SERVICE;
}
